import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { ICreditCardInfo } from "../../classes/Domain";

const VALIDATION = {
    INVALID_EXP_DATE: "Please specify card expiration in mm/yy format",
    INVALID_EXP_MONTH: "Expiration months should be between 01 and 12",
    REQUIRED_EXP_DATE: "Expiration month and year are required",
    EXPIRED: "Credit card is expired",
    INVALID_CC_NUMBER: "Credit card number is invalid"
};

const downPaymentRules = {
    downPaymentInstrument: {
        cardHolderFirstName: 'required',
        cardHolderLastName: 'required',
        cardExpirationFull: ['required', 'valid_mm_yy_date', 'valid_credit_card_exp_date'],
        cardNumber: ['required', 'valid_credit_card_number'],
        cardExpirationMonth: ['required', 'numeric', 'between:1,12'],
        cardExpirationYear: ['required', 'numeric']
    }
};


const installmentRules = {
    installmentInstrument: {
        cardHolderFirstName: 'required',
        cardHolderLastName: 'required',
        cardExpirationFull: ['required', 'valid_mm_yy_date', 'valid_credit_card_exp_date'],
        cardNumber: ['required', 'valid_credit_card_number'],
        cardExpirationMonth: ['required', 'numeric', 'between:1,12'],
        cardExpirationYear: ['required', 'numeric']
    }
};

const customErrorMessages = {
    "valid_credit_card_number": VALIDATION.INVALID_CC_NUMBER,
    "required.cardExpirationMonth": VALIDATION.REQUIRED_EXP_DATE,
    "required.cardExpirationYear": VALIDATION.REQUIRED_EXP_DATE,
    "numeric.cardExpirationMonth": VALIDATION.INVALID_EXP_DATE,
    "between.cardExpirationMonth": VALIDATION.INVALID_EXP_MONTH,
    "numeric.cardExpirationYear": VALIDATION.INVALID_EXP_DATE,
    "valid_credit_card_exp_date": VALIDATION.EXPIRED
};

export const allFieldsValidation = (data: { paymentInstrument: ICreditCardInfo, isInstallment: boolean }) => {

    if (!data.isInstallment) {
        return allFieldsValidationCommon({ downPaymentInstrument: data.paymentInstrument }, downPaymentRules, { ...customErrorMessagesCommon, ...customErrorMessages });
    }
    else {
        return allFieldsValidationCommon({ installmentInstrument: data.paymentInstrument }, installmentRules, { ...customErrorMessagesCommon, ...customErrorMessages });
    }
    
};